import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useTheme } from "@mui/material/styles";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function CloseAccess_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else CloseAccess_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const CloseAccess = (props)=>{
    const $ = c(40);
    const theme = useTheme();
    let t0;
    if ($[0] !== theme.tokens.colors.stroke.primary) {
        t0 = /*#__PURE__*/ jsx("circle", {
            cx: "37.422",
            cy: "37.422",
            r: "37.422",
            transform: "matrix(0.95738 0.288831 -0.280968 0.959717 31.0527 27.448)",
            fill: theme.tokens.colors.stroke.primary
        });
        $[0] = theme.tokens.colors.stroke.primary;
        $[1] = t0;
    } else t0 = $[1];
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M54.081 29.7767L51.2501 39.4463C50.4205 42.2799 47.4566 43.8856 44.6299 43.0329C41.8032 42.1801 40.1842 39.1917 41.0138 36.3581L43.8447 26.6885C47.4684 14.3109 60.5266 7.33007 73.0111 11.0965C85.4956 14.863 92.6787 27.9504 89.055 40.328L86.2241 49.9976C85.3946 52.8312 82.4306 54.4369 79.6039 53.5842C76.7772 52.7314 75.1583 49.743 75.9878 46.9094L78.8187 37.2398C80.8015 30.4672 76.8711 23.3061 70.04 21.2452C63.2088 19.1844 56.0638 23.004 54.081 29.7767Z",
            fill: "#85AAF2"
        });
        $[2] = t1;
    } else t1 = $[2];
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ jsx("g", {
            filter: "url(#filter1_iiii_8195_6585)",
            children: /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M52.59 29.6126L49.711 39.4463C48.8815 42.2799 45.9175 43.8856 43.0908 43.0329C40.2641 42.1801 38.6452 39.1917 39.4747 36.3581L42.3537 26.5244C46.0176 14.0094 59.1084 6.91732 71.5929 10.6838C84.0774 14.4502 91.2279 27.6489 87.564 40.1639L84.6851 49.9976C83.8555 52.8312 80.8915 54.4369 78.0649 53.5842C75.2382 52.7314 73.6192 49.743 74.4488 46.9094L77.3277 37.0757C79.3325 30.2279 75.4199 23.0059 68.5888 20.9451C61.7577 18.8842 54.5947 22.7648 52.59 29.6126Z",
                fill: "#99BCFF"
            })
        });
        $[3] = t2;
    } else t2 = $[3];
    let t3;
    let t4;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ jsxs("g", {
            filter: "url(#filter2_i_8195_6585)",
            children: [
                /*#__PURE__*/ jsx("circle", {
                    cx: "37.422",
                    cy: "37.422",
                    r: "37.422",
                    transform: "matrix(0.95738 0.288831 -0.280968 0.959717 28.1807 27.3704)",
                    fill: "url(#paint0_linear_8195_6585)"
                }),
                /*#__PURE__*/ jsx("circle", {
                    cx: "37.422",
                    cy: "37.422",
                    r: "37.422",
                    transform: "matrix(0.95738 0.288831 -0.280968 0.959717 28.1807 27.3704)",
                    fill: "url(#paint1_linear_8195_6585)",
                    fillOpacity: "0.4"
                })
            ]
        });
        t4 = /*#__PURE__*/ jsx("circle", {
            cx: "37.422",
            cy: "37.422",
            r: "36.531",
            transform: "matrix(0.95738 0.288831 -0.280968 0.959717 28.1807 27.3704)",
            stroke: "url(#paint2_linear_8195_6585)",
            strokeWidth: "1.782"
        });
        t5 = /*#__PURE__*/ jsx("circle", {
            cx: "24.948",
            cy: "24.948",
            r: "24.948",
            transform: "matrix(0.95738 0.288831 -0.280968 0.959717 37.502 43.0615)",
            fill: "#85AAF2"
        });
        $[4] = t3;
        $[5] = t4;
        $[6] = t5;
    } else {
        t3 = $[4];
        t4 = $[5];
        t5 = $[6];
    }
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = /*#__PURE__*/ jsx("g", {
            filter: "url(#filter3_d_8195_6585)",
            children: /*#__PURE__*/ jsx("circle", {
                cx: "24.948",
                cy: "24.948",
                r: "24.948",
                transform: "matrix(0.95738 0.288831 -0.280968 0.959717 36.6182 42.9429)",
                fill: "#99BCFF"
            })
        });
        $[7] = t6;
    } else t6 = $[7];
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = /*#__PURE__*/ jsxs("g", {
            filter: "url(#filter4_i_8195_6585)",
            children: [
                /*#__PURE__*/ jsx("circle", {
                    cx: "15.147",
                    cy: "15.147",
                    r: "15.147",
                    transform: "matrix(0.95738 0.288831 -0.280968 0.959717 43.248 55.1807)",
                    fill: "url(#paint3_linear_8195_6585)"
                }),
                /*#__PURE__*/ jsx("circle", {
                    cx: "15.147",
                    cy: "15.147",
                    r: "15.147",
                    transform: "matrix(0.95738 0.288831 -0.280968 0.959717 43.248 55.1807)",
                    fill: "white",
                    fillOpacity: "0.2"
                })
            ]
        });
        $[8] = t7;
    } else t7 = $[8];
    let t8;
    if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = /*#__PURE__*/ jsxs("g", {
            filter: "url(#filter5_i_8195_6585)",
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M47.6334 90.9329C47.7717 90.4608 48.2661 90.1936 48.7372 90.3357C49.208 90.478 49.4773 90.9759 49.339 91.4481L48.088 95.7232C47.9498 96.1955 47.4552 96.4635 46.9841 96.3214C46.5132 96.1792 46.2432 95.681 46.3812 95.2089L47.6334 90.9329ZM61.5907 89.0342C62.0216 88.8008 62.5622 88.964 62.7976 89.3984L64.9278 93.3317C65.163 93.7662 65.005 94.3077 64.5741 94.5411C64.1434 94.7743 63.6036 94.6111 63.3682 94.177L61.237 90.2436C61.0017 89.8092 61.16 89.2677 61.5907 89.0342ZM37.4629 81.7552C37.8938 81.5218 38.4344 81.685 38.6698 82.1194C38.9051 82.5538 38.7461 83.0951 38.3152 83.3286L34.4146 85.4426C33.9837 85.676 33.4431 85.5128 33.2077 85.0784C32.9724 84.644 33.1315 84.1026 33.5623 83.8692L37.4629 81.7552ZM70.8057 78.382L75.07 79.6689C75.5411 79.8111 75.8111 80.3092 75.6729 80.7814C75.5346 81.2535 75.0409 81.5215 74.5699 81.3797L70.3046 80.0925C69.8335 79.9504 69.5635 79.4523 69.7017 78.9801C69.84 78.5078 70.3345 78.2398 70.8057 78.382ZM31.3148 67.3961C31.4533 66.9241 31.9477 66.6569 32.4186 66.7989L36.684 68.0861C37.1548 68.2284 37.4241 68.7263 37.2858 69.1984C37.1474 69.6703 36.6539 69.9377 36.183 69.7957L31.9177 68.5086C31.4467 68.3664 31.1766 67.8683 31.3148 67.3961ZM72.5723 62.7339C73.0032 62.5004 73.5438 62.6636 73.7792 63.098C74.0142 63.5324 73.8553 64.0739 73.4246 64.3072L69.5241 66.4202C69.0932 66.6537 68.5526 66.4905 68.3172 66.0561C68.0821 65.6217 68.2411 65.0802 68.6718 64.8469L72.5723 62.7339ZM42.4136 53.6364C42.8445 53.4032 43.3842 53.5661 43.6195 54.0005L45.7508 57.933C45.9862 58.3674 45.827 58.9097 45.3961 59.1431C44.9654 59.3762 44.4255 59.2132 44.1901 58.7791L42.059 54.8456C41.8237 54.4112 41.9827 53.8699 42.4136 53.6364ZM58.899 52.4522C59.0374 51.9802 59.5318 51.713 60.0028 51.855C60.4737 51.9973 60.7429 52.4952 60.6047 52.9674L59.3537 57.2426C59.2154 57.7148 58.7208 57.9828 58.2497 57.8407C57.7788 57.6984 57.5087 57.2003 57.6469 56.7282L58.899 52.4522Z",
                    fill: "url(#paint4_linear_8195_6585)"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M47.6334 90.9329C47.7717 90.4608 48.2661 90.1936 48.7372 90.3357C49.208 90.478 49.4773 90.9759 49.339 91.4481L48.088 95.7232C47.9498 96.1955 47.4552 96.4635 46.9841 96.3214C46.5132 96.1792 46.2432 95.681 46.3812 95.2089L47.6334 90.9329ZM61.5907 89.0342C62.0216 88.8008 62.5622 88.964 62.7976 89.3984L64.9278 93.3317C65.163 93.7662 65.005 94.3077 64.5741 94.5411C64.1434 94.7743 63.6036 94.6111 63.3682 94.177L61.237 90.2436C61.0017 89.8092 61.16 89.2677 61.5907 89.0342ZM37.4629 81.7552C37.8938 81.5218 38.4344 81.685 38.6698 82.1194C38.9051 82.5538 38.7461 83.0951 38.3152 83.3286L34.4146 85.4426C33.9837 85.676 33.4431 85.5128 33.2077 85.0784C32.9724 84.644 33.1315 84.1026 33.5623 83.8692L37.4629 81.7552ZM70.8057 78.382L75.07 79.6689C75.5411 79.8111 75.8111 80.3092 75.6729 80.7814C75.5346 81.2535 75.0409 81.5215 74.5699 81.3797L70.3046 80.0925C69.8335 79.9504 69.5635 79.4523 69.7017 78.9801C69.84 78.5078 70.3345 78.2398 70.8057 78.382ZM31.3148 67.3961C31.4533 66.9241 31.9477 66.6569 32.4186 66.7989L36.684 68.0861C37.1548 68.2284 37.4241 68.7263 37.2858 69.1984C37.1474 69.6703 36.6539 69.9377 36.183 69.7957L31.9177 68.5086C31.4467 68.3664 31.1766 67.8683 31.3148 67.3961ZM72.5723 62.7339C73.0032 62.5004 73.5438 62.6636 73.7792 63.098C74.0142 63.5324 73.8553 64.0739 73.4246 64.3072L69.5241 66.4202C69.0932 66.6537 68.5526 66.4905 68.3172 66.0561C68.0821 65.6217 68.2411 65.0802 68.6718 64.8469L72.5723 62.7339ZM42.4136 53.6364C42.8445 53.4032 43.3842 53.5661 43.6195 54.0005L45.7508 57.933C45.9862 58.3674 45.827 58.9097 45.3961 59.1431C44.9654 59.3762 44.4255 59.2132 44.1901 58.7791L42.059 54.8456C41.8237 54.4112 41.9827 53.8699 42.4136 53.6364ZM58.899 52.4522C59.0374 51.9802 59.5318 51.713 60.0028 51.855C60.4737 51.9973 60.7429 52.4952 60.6047 52.9674L59.3537 57.2426C59.2154 57.7148 58.7208 57.9828 58.2497 57.8407C57.7788 57.6984 57.5087 57.2003 57.6469 56.7282L58.899 52.4522Z",
                    fill: "white",
                    fillOpacity: "0.2"
                })
            ]
        });
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== t0) {
        t9 = /*#__PURE__*/ jsxs("g", {
            filter: "url(#filter0_dd_8195_6585)",
            children: [
                t0,
                t1,
                t2,
                t3,
                t4,
                t5,
                t6,
                t7,
                t8
            ]
        });
        $[10] = t0;
        $[11] = t9;
    } else t9 = $[11];
    let t10;
    let t11;
    let t12;
    let t13;
    let t14;
    let t15;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = /*#__PURE__*/ jsx("rect", {
            x: "20.5098",
            y: "34.1516",
            width: "10.0409",
            height: "2.8454",
            rx: "1.42857",
            transform: "rotate(-132.756 20.5098 34.1516)",
            fill: "#99BCFF"
        });
        t11 = /*#__PURE__*/ jsx("rect", {
            x: "12.0889",
            y: "45.9077",
            width: "10.0409",
            height: "2.8454",
            rx: "1.42857",
            transform: "rotate(-176.933 12.0889 45.9077)",
            fill: "#99BCFF"
        });
        t12 = /*#__PURE__*/ jsx("rect", {
            x: "32.0127",
            y: "25.6731",
            width: "10.0409",
            height: "2.8454",
            rx: "1.42857",
            transform: "rotate(-106.855 32.0127 25.6731)",
            fill: "#99BCFF"
        });
        t13 = /*#__PURE__*/ jsx("rect", {
            x: "99.4541",
            y: "38.6299",
            width: "10.0409",
            height: "2.8454",
            rx: "1.42857",
            transform: "rotate(-27.1629 99.4541 38.6299)",
            fill: "#99BCFF"
        });
        t14 = /*#__PURE__*/ jsx("rect", {
            x: "100.136",
            y: "52.9609",
            width: "10.0409",
            height: "2.8454",
            rx: "1.42857",
            transform: "rotate(8.73951 100.136 52.9609)",
            fill: "#99BCFF"
        });
        t15 = /*#__PURE__*/ jsx("rect", {
            x: "99.7354",
            y: "63.9651",
            width: "10.0409",
            height: "2.8454",
            rx: "1.42857",
            transform: "rotate(39.4697 99.7354 63.9651)",
            fill: "#99BCFF"
        });
        $[12] = t10;
        $[13] = t11;
        $[14] = t12;
        $[15] = t13;
        $[16] = t14;
        $[17] = t15;
    } else {
        t10 = $[12];
        t11 = $[13];
        t12 = $[14];
        t13 = $[15];
        t14 = $[16];
        t15 = $[17];
    }
    let t16;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t16 = /*#__PURE__*/ jsxs("filter", {
            id: "filter0_dd_8195_6585",
            x: "11.2957",
            y: "7.22902",
            width: "95.3475",
            height: "121.483",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                }),
                /*#__PURE__*/ jsx("feOffset", {
                    dx: "0.91824",
                    dy: "1.84893"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "2.14674"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    type: "matrix",
                    values: "0 0 0 0 0.305882 0 0 0 0 0.301961 0 0 0 0 0.364706 0 0 0 0.25 0"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_8195_6585"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                }),
                /*#__PURE__*/ jsx("feOffset", {
                    dx: "4.04026",
                    dy: "8.13528"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "4.44502"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    type: "matrix",
                    values: "0 0 0 0 0.305882 0 0 0 0 0.301961 0 0 0 0 0.364706 0 0 0 0.12 0"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in2: "effect1_dropShadow_8195_6585",
                    result: "effect2_dropShadow_8195_6585"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "effect2_dropShadow_8195_6585",
                    result: "shape"
                })
            ]
        });
        $[18] = t16;
    } else t16 = $[18];
    let t17;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = /*#__PURE__*/ jsxs("filter", {
            id: "filter1_iiii_8195_6585",
            x: "36.5848",
            y: "7.89158",
            width: "55.5026",
            height: "49.4854",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                }),
                /*#__PURE__*/ jsx("feOffset", {
                    dx: "3.564",
                    dy: "2.673"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "1.782"
                }),
                /*#__PURE__*/ jsx("feComposite", {
                    in2: "hardAlpha",
                    operator: "arithmetic",
                    k2: "-1",
                    k3: "1"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    type: "matrix",
                    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in2: "shape",
                    result: "effect1_innerShadow_8195_6585"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                }),
                /*#__PURE__*/ jsx("feOffset", {
                    dx: "1.782",
                    dy: "3.564"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "1.782"
                }),
                /*#__PURE__*/ jsx("feComposite", {
                    in2: "hardAlpha",
                    operator: "arithmetic",
                    k2: "-1",
                    k3: "1"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    type: "matrix",
                    values: "0 0 0 0 0.521569 0 0 0 0 0.666667 0 0 0 0 0.94902 0 0 0 0.7 0"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in2: "effect1_innerShadow_8195_6585",
                    result: "effect2_innerShadow_8195_6585"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                }),
                /*#__PURE__*/ jsx("feOffset", {
                    dx: "-2.673",
                    dy: "-1.782"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "1.3365"
                }),
                /*#__PURE__*/ jsx("feComposite", {
                    in2: "hardAlpha",
                    operator: "arithmetic",
                    k2: "-1",
                    k3: "1"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    type: "matrix",
                    values: "0 0 0 0 0.521569 0 0 0 0 0.666667 0 0 0 0 0.94902 0 0 0 0.5 0"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in2: "effect2_innerShadow_8195_6585",
                    result: "effect3_innerShadow_8195_6585"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                }),
                /*#__PURE__*/ jsx("feOffset", {
                    dx: "-0.891",
                    dy: "-0.891"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "0.891"
                }),
                /*#__PURE__*/ jsx("feComposite", {
                    in2: "hardAlpha",
                    operator: "arithmetic",
                    k2: "-1",
                    k3: "1"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    type: "matrix",
                    values: "0 0 0 0 0.521569 0 0 0 0 0.666667 0 0 0 0 0.94902 0 0 0 0.8 0"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in2: "effect3_innerShadow_8195_6585",
                    result: "effect4_innerShadow_8195_6585"
                })
            ]
        });
        $[19] = t17;
    } else t17 = $[19];
    let t18;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
        t18 = /*#__PURE__*/ jsxs("filter", {
            id: "filter2_i_8195_6585",
            x: "16.1455",
            y: "36.5779",
            width: "78.2531",
            height: "79.775",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                }),
                /*#__PURE__*/ jsx("feOffset", {
                    dx: "3.55778",
                    dy: "7.11555"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "2.37185"
                }),
                /*#__PURE__*/ jsx("feComposite", {
                    in2: "hardAlpha",
                    operator: "arithmetic",
                    k2: "-1",
                    k3: "1"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    type: "matrix",
                    values: "0 0 0 0 0.886275 0 0 0 0 0.901961 0 0 0 0 0.921569 0 0 0 0.4 0"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in2: "shape",
                    result: "effect1_innerShadow_8195_6585"
                })
            ]
        });
        $[20] = t18;
    } else t18 = $[20];
    let t19;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
        t19 = /*#__PURE__*/ jsxs("filter", {
            id: "filter3_d_8195_6585",
            x: "25.9911",
            y: "47.6118",
            width: "61.5529",
            height: "61.7767",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                }),
                /*#__PURE__*/ jsx("feOffset", {
                    dx: "3.27441",
                    dy: "4.40849"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "2.939"
                }),
                /*#__PURE__*/ jsx("feComposite", {
                    in2: "hardAlpha",
                    operator: "out"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    type: "matrix",
                    values: "0 0 0 0 0.521569 0 0 0 0 0.666667 0 0 0 0 0.94902 0 0 0 0.4 0"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in2: "BackgroundImageFix",
                    result: "effect1_dropShadow_8195_6585"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "effect1_dropShadow_8195_6585",
                    result: "shape"
                })
            ]
        });
        $[21] = t19;
    } else t19 = $[21];
    let t20;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = /*#__PURE__*/ jsxs("filter", {
            id: "filter4_i_8195_6585",
            x: "38.377",
            y: "58.9075",
            width: "30.2334",
            height: "33.3089",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                }),
                /*#__PURE__*/ jsx("feOffset", {
                    dy: "2.939"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "2.939"
                }),
                /*#__PURE__*/ jsx("feComposite", {
                    in2: "hardAlpha",
                    operator: "arithmetic",
                    k2: "-1",
                    k3: "1"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    type: "matrix",
                    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in2: "shape",
                    result: "effect1_innerShadow_8195_6585"
                })
            ]
        });
        $[22] = t20;
    } else t20 = $[22];
    let t21;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
        t21 = /*#__PURE__*/ jsxs("filter", {
            id: "filter5_i_8195_6585",
            x: "31.2783",
            y: "51.8169",
            width: "44.4307",
            height: "46.3245",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
                /*#__PURE__*/ jsx("feFlood", {
                    floodOpacity: "0",
                    result: "BackgroundImageFix"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in: "SourceGraphic",
                    in2: "BackgroundImageFix",
                    result: "shape"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    in: "SourceAlpha",
                    type: "matrix",
                    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                    result: "hardAlpha"
                }),
                /*#__PURE__*/ jsx("feOffset", {
                    dy: "1.782"
                }),
                /*#__PURE__*/ jsx("feGaussianBlur", {
                    stdDeviation: "0.891"
                }),
                /*#__PURE__*/ jsx("feComposite", {
                    in2: "hardAlpha",
                    operator: "arithmetic",
                    k2: "-1",
                    k3: "1"
                }),
                /*#__PURE__*/ jsx("feColorMatrix", {
                    type: "matrix",
                    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0"
                }),
                /*#__PURE__*/ jsx("feBlend", {
                    mode: "normal",
                    in2: "shape",
                    result: "effect1_innerShadow_8195_6585"
                })
            ]
        });
        $[23] = t21;
    } else t21 = $[23];
    let t22;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
        t22 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint0_linear_8195_6585",
            x1: "0",
            y1: "0",
            x2: "60.2773",
            y2: "92.1303",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "white"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "#F3F3F4"
                })
            ]
        });
        $[24] = t22;
    } else t22 = $[24];
    let t23;
    if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint1_linear_8195_6585",
            x1: "8.64117",
            y1: "2.16133",
            x2: "68.4576",
            y2: "67.5453",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "white"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "white",
                    stopOpacity: "0"
                })
            ]
        });
        $[25] = t23;
    } else t23 = $[25];
    let t24;
    if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
        t24 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint2_linear_8195_6585",
            x1: "-4.66173",
            y1: "-25.0987",
            x2: "58.5483",
            y2: "131.003",
            gradientUnits: "userSpaceOnUse",
            children: [
                /*#__PURE__*/ jsx("stop", {
                    stopColor: "white",
                    stopOpacity: "0.8"
                }),
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: "white",
                    stopOpacity: "0.1"
                })
            ]
        });
        $[26] = t24;
    } else t24 = $[26];
    let t25;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
        t25 = /*#__PURE__*/ jsx("stop", {
            stopColor: "#F7FBFF"
        });
        $[27] = t25;
    } else t25 = $[27];
    let t26;
    if ($[28] !== theme.tokens.colors.stroke.primary) {
        t26 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint3_linear_8195_6585",
            x1: "-0.316975",
            y1: "1.22582",
            x2: "-0.0684416",
            y2: "27.2658",
            gradientUnits: "userSpaceOnUse",
            children: [
                t25,
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: theme.tokens.colors.stroke.primary
                })
            ]
        });
        $[28] = theme.tokens.colors.stroke.primary;
        $[29] = t26;
    } else t26 = $[29];
    let t27;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
        t27 = /*#__PURE__*/ jsx("stop", {
            stopColor: "#F7FBFF"
        });
        $[30] = t27;
    } else t27 = $[30];
    let t28;
    if ($[31] !== theme.tokens.colors.stroke.primary) {
        t28 = /*#__PURE__*/ jsxs("linearGradient", {
            id: "paint4_linear_8195_6585",
            x1: "46.0041",
            y1: "49.9016",
            x2: "34.5134",
            y2: "82.6615",
            gradientUnits: "userSpaceOnUse",
            children: [
                t27,
                /*#__PURE__*/ jsx("stop", {
                    offset: "1",
                    stopColor: theme.tokens.colors.stroke.primary
                })
            ]
        });
        $[31] = theme.tokens.colors.stroke.primary;
        $[32] = t28;
    } else t28 = $[32];
    let t29;
    if ($[33] !== t26 || $[34] !== t28) {
        t29 = /*#__PURE__*/ jsxs("defs", {
            children: [
                t16,
                t17,
                t18,
                t19,
                t20,
                t21,
                t22,
                t23,
                t24,
                t26,
                t28
            ]
        });
        $[33] = t26;
        $[34] = t28;
        $[35] = t29;
    } else t29 = $[35];
    let t30;
    if ($[36] !== props || $[37] !== t29 || $[38] !== t9) {
        t30 = /*#__PURE__*/ jsxs("svg", _object_spread_props(_object_spread({}, props), {
            xmlns: "http://www.w3.org/2000/svg",
            width: "120",
            height: "129",
            viewBox: "0 0 120 129",
            fill: "none",
            children: [
                t9,
                t10,
                t11,
                t12,
                t13,
                t14,
                t15,
                t29
            ]
        }));
        $[36] = props;
        $[37] = t29;
        $[38] = t9;
        $[39] = t30;
    } else t30 = $[39];
    return t30;
};
export { CloseAccess };
